import { render } from "./IconDate.vue?vue&type=template&id=6eb3571a"
import script from "./IconDate.vue?vue&type=script&lang=js"
export * from "./IconDate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__